/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { DataStoreProvider } from "./lib/store/data-store";
import { ExpertModeProvider } from "./lib/store/expert-mode-store";
import { SynthwaveProvider } from "./lib/store/synthwave-store";
import { AuthProvider } from "./lib/store/auth-store";
import { MusicPlayerProvider } from "./lib/store/music-player-store";

const elem = document.getElementById("root")!;
const app = (
  <StrictMode>
    <AuthProvider>
      <ExpertModeProvider>
        <SynthwaveProvider>
          <MusicPlayerProvider>
            <DataStoreProvider>
              <App />
            </DataStoreProvider>
          </MusicPlayerProvider>
        </SynthwaveProvider>
      </ExpertModeProvider>
    </AuthProvider>
  </StrictMode>
);

if (import.meta.hot) {
  // With hot module reloading, `import.meta.hot.data` is persisted.
  const root = (import.meta.hot.data.root ??= createRoot(elem));
  root.render(app);
} else {
  // The hot module reloading API is not available in production.
  createRoot(elem).render(app);
}
